import { bookingStore } from 'entities/booking';
import { specializationsStore } from 'entities/specializations/store/store';
import { Specialization } from 'entities/specializations/store/types';
import { doctorsStore } from 'features/doctors';
import { Doctor } from 'features/doctors/store/types';
import { DoctorCardInfo } from 'features/doctors/ui/doctorsCards/doctorCard/doctorCardInfo';
import { observer } from 'mobx-react-lite';
import { FC, useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlphabeticalItemsList, TItem } from 'shared/ui/alphabeticalItems';
import { PreloaderWrapper, withPreloader } from 'shared/ui/preloader';

const AlphabeticalSpecsListWrapper = withPreloader(PreloaderWrapper);

type SpecializationsListProps = {
  query?: string
}

export const SpecializationsList: FC<SpecializationsListProps> = observer(({
  query = ''
}) => {
	const navigate = useNavigate();
  const [ specs, setSpecs ] = useState<Specialization[]>([]);
  const [ doctors, setDoctors ] = useState<Doctor[]>([])

  const getSpecs = useCallback(async () => {
		await specializationsStore.fetchSpecializations();
    setSpecs(specializationsStore.getSpecializations(query).map(spec => spec));
  }, [setSpecs, query])

	useEffect(() => {
    getSpecs();
    // eslint-disable-next-line
	}, []);

  const search = async (query: string = '') => {
    if (!query.trim()) {
      setDoctors([]);
      return setSpecs(specializationsStore.getSpecializations(query).map(spec => spec));
    }

    const searchRes = await doctorsStore.searchDoctors(query);
    if (searchRes.length) {
      return setDoctors(searchRes)
    }

    setDoctors([]);
    setSpecs(specializationsStore.getSpecializations(query).map(spec => spec));
  }

  useEffect(() => {
    search(query);
  }, [query])

	const selectSpecializtion = async (item: TItem) => {
    if (bookingStore.specialization?.id !== item.id) {
      await bookingStore.setClinics([]);
    }
		await bookingStore.setSpecialization(item as Specialization);
		navigate('/clinics');
	};

  if (doctors.length) {
    return (
      <AlphabeticalSpecsListWrapper
        isLoading={specializationsStore.loading}
        error={specializationsStore.error}
      >
        {doctors.map((doctor) => (
          <DoctorCardInfo doctor={doctor} key={doctor.id} showLink showDetails />
        ))}
      </AlphabeticalSpecsListWrapper>
    );
  }

	return (
		<AlphabeticalSpecsListWrapper
			isLoading={specializationsStore.loading}
			error={specializationsStore.error}
		>
      {specs.length ? 
			<AlphabeticalItemsList
				items={specs}
				onSelect={selectSpecializtion}
			/> : 
      <>Ничего не найдено</>
      }
		</AlphabeticalSpecsListWrapper>
	);
});
